import { Injectable } from '@angular/core';
import { Observable } from 'rxjs/Observable';
import { Subject } from 'rxjs/Subject';
import { Subscriber } from 'rxjs/Subscriber';

export interface IUploadOptions {
  url: string;
  method: 'post' | 'put';
  file?: File;
  headers?: {[key: string]: string};
  formData?: FormData;
}
export class TdFileService {
private _progressSubject: Subject<number> = new Subject<number>();
private _progressObservable: Observable<number>;
/**
 * Gets progress observable to keep track of the files being uploaded.
 * Needs to be supported by backend.
 * @return {?}
 */
get progress(): Observable<number> {
    return this._progressObservable;
  }
constructor() {
    this._progressObservable = this._progressSubject.asObservable();
  }
/**
 * params:
 * - options: IUploadOptions {
 *     url: string,
 *     method: 'post' | 'put',
 *     file?: File,
 *     headers?: {[key: string]: string},
 *     formData?: FormData
 * }
 * 
 * Uses underlying [XMLHttpRequest] to upload a file to a url.
 * Will be depricated when angular fixes [Http] to allow [FormData] as body.
 * @param {?} options
 * @return {?}
 */
upload(options: IUploadOptions): Observable<any> {
    return new Observable<any>((subscriber: Subscriber<any>) => {
      let /** @type {?} */ xhr: XMLHttpRequest = new XMLHttpRequest();      
      let /** @type {?} */ formData: FormData = new FormData();

      if (options.file !== undefined) {
        formData.append('file', options.file);
      } else if (options.formData !== undefined) {
        formData = options.formData;
      } else {
        return subscriber.error('For [IUploadOptions] you have to set either the [file] or the [formData] property.');
      }      

      xhr.onprogress = (event: ProgressEvent) => {
        let /** @type {?} */ progress: number = 0;
        if (event.total > 0) {
          progress = Math.round(event.loaded / event.total * 100);
        }
        this._progressSubject.next(progress);
      };

      xhr.onreadystatechange = () => {
        if (xhr.readyState === 4) {
          if (xhr.status === 200 || xhr.status === 201) {
            subscriber.next(JSON.parse(xhr.response));
            subscriber.complete();
          } else {
            subscriber.error(xhr.response);
          }
        }
      };

      xhr.open(options.method, options.url, true);
      xhr.setRequestHeader('X-Requested-With', 'XMLHttpRequest');
      if (options.headers) {
        for (let /** @type {?} */ key in options.headers) {
          xhr.setRequestHeader(key, options.headers[key]);
        }
      }

      xhr.send(formData);
    });
  }
static decorators: DecoratorInvocation[] = [
{ type: Injectable },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function TdFileService_tsickle_Closure_declarations() {
/** @type {?} */
TdFileService.decorators;
/**
 * @nocollapse
 * @type {?}
 */
TdFileService.ctorParameters;
/** @type {?} */
TdFileService.prototype._progressSubject;
/** @type {?} */
TdFileService.prototype._progressObservable;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
